module.exports = {"210303001":"启明街道","210303002":"繁荣街道","210303003":"八家子街道","210303004":"兴盛街道","210303005":"共和街道","210303006":"永乐街道","210303007":"北陶官街道","210303008":"南华街道","210303009":"大陆街道","210303010":"新陶官街道","210303011":"新城街道","210303012":"永发街道","210303013":"宁远街道","210303014":"达道湾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210303.json
// module id = 478
// module chunks = 0